import { Tier } from 'features/premium/entities';
import { UnavailableOnWebModal } from 'utils/packages/UnavailableOnWebModal';
export const UpgradeWebModal = {
    show: (tier = Tier.ultimate) => {
        UnavailableOnWebModal.show(`emma://upgrade/false/${tier}`, 'Upgrade plan');
    },
    hide: UnavailableOnWebModal.hide,
};
